function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link';
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { iam } from '../profile/access';
var client = {};
export default (function (appsyncUrl) {
  var typePolicies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _iam = iam(),
    getAuthSession = _iam.getAuthSession,
    getJWTToken = _iam.getJWTToken,
    getTempAWSCreds = _iam.getTempAWSCreds;
  var headers = setContext(function (request, _ref) {
    var headers = _ref.headers;
    return {
      headers: _objectSpread(_objectSpread({}, headers), {}, {
        'x-cb-catapult-authorization-token': getJWTToken(),
        'x-cb-catapult-authentication-token': getAuthSession().sessionId
      })
    };
  });
  var appsyncConfig = {
    url: appsyncUrl,
    region: 'us-east-1',
    auth: {
      type: AUTH_TYPE.AWS_IAM,
      credentials: function credentials() {
        return getTempAWSCreds('apfym');
      }
    }
  };
  var appsyncLink = new ApolloLink.from([createAuthLink(_objectSpread(_objectSpread({}, appsyncConfig), {}, {
    disableOffline: true
  })), createSubscriptionHandshakeLink(appsyncConfig)]);
  if (!client[appsyncUrl]) client[appsyncUrl] = new ApolloClient({
    link: headers.concat(appsyncLink),
    cache: new InMemoryCache({
      typePolicies: _objectSpread({
        teacherRegistration: {
          keyFields: ['userId']
        },
        studentRegistration: {
          merge: true
        }
      }, typePolicies)
    })
  });
  return client[appsyncUrl];
});